module.exports = __webpack_public_path__ + "img/1estrella.21644ab6.png";